let ip = 'http://192.168.1.185:8000/api/v1'
let ipSocket = 'http://192.168.1.185:8000'
let siteUrl = 'http://192.168.1.185:3000'

if (1 === 1) {
    ip = 'https://kiwuiserver.onrender.com/api/v1'
    ipSocket = 'https://kiwuiserver.onrender.com'
    siteUrl = 'https://kiwuimap.onrender.com'
}

export const ServerIP = ip;
export const ServerSocketIP = ipSocket;
export const SiteUrl = siteUrl;
export const MapUrl = 'https://tiles.openfreemap.org/styles/liberty'

